export default {
  Highcharts: 'chart',
  Highstock: 'stockChart',
  Highmaps: 'mapChart',
  HighchartsGantt: 'ganttChart',
};
